var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from "class-transformer";
import { safeAssign } from "./safe-assign";
export class TimeLogDeviceDTO {
    constructor(init) {
        safeAssign(this, init);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], TimeLogDeviceDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], TimeLogDeviceDTO.prototype, "companyId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], TimeLogDeviceDTO.prototype, "connectionCode", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], TimeLogDeviceDTO.prototype, "description", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], TimeLogDeviceDTO.prototype, "filters", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], TimeLogDeviceDTO.prototype, "type", void 0);
__decorate([
    Expose(),
    Type(() => Date),
    __metadata("design:type", Date)
], TimeLogDeviceDTO.prototype, "lastActive", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], TimeLogDeviceDTO.prototype, "displaySchedule", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], TimeLogDeviceDTO.prototype, "displayUpcoming", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], TimeLogDeviceDTO.prototype, "displayActive", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], TimeLogDeviceDTO.prototype, "colorScheme", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], TimeLogDeviceDTO.prototype, "legacy", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], TimeLogDeviceDTO.prototype, "appVersion", void 0);
//# sourceMappingURL=time-log-device.dto.js.map